// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"917ed66f","343":"917ed66f","377":"58b7ed5b","664":"7a18533b","759":"2c5cadb0","767":"917ed66f","808":"58b7ed5b","874":"1e504de8"}[chunkId] + ".chunk.css";
};